import React from 'react';
import { Link } from 'react-router-dom';
import VisualizerBackground from '../components/VisualizerBackground';

const Terms = () => {
  return (
    <div className="min-h-screen bg-drummer-dark text-white">
      <VisualizerBackground />
      
      <div className="container mx-auto px-4 pt-32 pb-16">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold mb-8 text-client-yellow">Terms of Use</h1>
          
          <div className="prose prose-lg prose-invert">
            <p className="text-white mb-6">
              Last updated: April 8, 2025
            </p>
            
            <h2 className="text-2xl font-bold text-client-yellow mt-8 mb-4">1. Agreement to Terms</h2>
            <p className="text-white mb-6">
              These Terms of Use constitute a legally binding agreement made between you, whether personally or on behalf of an entity 
              ("you") and Daryian Kelton ("we," "us" or "our"), concerning your access to and use of the website as well as any 
              other media form, media channel, mobile website or mobile application related, linked, or otherwise connected thereto (collectively, the "Site").
            </p>
            
            <h2 className="text-2xl font-bold text-client-yellow mb-4">2. Intellectual Property Rights</h2>
            <p className="text-white mb-4">
              The Content and Marks are protected by copyright and trademark laws (both registered and unregistered) and other intellectual property rights and unfair competition laws of the United States, foreign jurisdictions, and international conventions.
            </p>
            <p className="text-white mb-4">
              The Content and Marks are provided in or through the Services "AS IS" for your personal, non-commercial use or internal business purpose only.
            </p>
            
            <h2 className="text-2xl font-bold text-client-yellow mb-4">3. User Representations</h2>
            <p className="text-white mb-4">
              By using the Services, you represent and warrant that:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2 text-white">
              <li>All registration information you submit will be true, accurate, current, and complete</li>
              <li>You will maintain the accuracy of such information and promptly update such registration information as necessary</li>
              <li>You have the legal capacity and you agree to comply with these Legal Terms</li>
              <li>You are not a minor in the jurisdiction in which you reside</li>
              <li>You will not access the Services through automated or non-human means</li>
              <li>You will not use the Services for any illegal or unauthorized purpose</li>
              <li>Your use of the Services will not violate any applicable law or regulation</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-client-yellow mb-4">4. Prohibited Activities</h2>
            <p className="text-white mb-4">
              You may not access or use the Services for any purpose other than that for which we make the Services available. The Services may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us.
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2 text-white">
              <li>Systematically retrieve data or other content from the Services to create or compile, directly or indirectly, a collection, compilation, database, or directory without written permission from us</li>
              <li>Trick, defraud, or mislead us and other users, especially in any attempt to learn sensitive account information such as user passwords</li>
              <li>Circumvent, disable, or otherwise interfere with security-related features of the Services</li>
              <li>Disparage, tarnish, or otherwise harm, in our opinion, us and/or the Services</li>
              <li>Use any information obtained from the Services in order to harass, abuse, or harm another person</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-client-yellow mt-8 mb-4">5. Submissions</h2>
            <p className="text-white mb-6">
              You acknowledge and agree that any questions, comments, suggestions, ideas, feedback, or other information regarding 
              the Site ("Submissions") provided by you to us are non-confidential and shall become our sole property. We shall own 
              exclusive rights, including all intellectual property rights, and shall be entitled to the unrestricted use and 
              dissemination of these Submissions for any lawful purpose, commercial or otherwise, without acknowledgment or 
              compensation to you.
            </p>
            
            <h2 className="text-2xl font-bold text-client-yellow mt-8 mb-4">6. Site Management</h2>
            <p className="text-white mb-6">
              We reserve the right, but not the obligation, to: (1) monitor the Site for violations of these Terms of Use; (2) take 
              appropriate legal action against anyone who, in our sole discretion, violates the law or these Terms of Use, including 
              without limitation, reporting such user to law enforcement authorities; (3) in our sole discretion and without limitation, 
              refuse, restrict access to, limit the availability of, or disable (to the extent technologically feasible) any of your 
              Contributions or any portion thereof; (4) in our sole discretion and without limitation, notice, or liability, to remove 
              from the Site or otherwise disable all files and content that are excessive in size or are in any way burdensome to our systems; 
              and (5) otherwise manage the Site in a manner designed to protect our rights and property and to facilitate the proper 
              functioning of the Site.
            </p>
            
            <h2 className="text-2xl font-bold text-client-yellow mt-8 mb-4">7. Term and Termination</h2>
            <p className="text-white mb-6">
              These Terms of Use shall remain in full force and effect while you use the Site. Without limiting any other provision 
              of these terms of use, we reserve the right to, in our sole discretion and without notice or liability, deny access 
              to and use of the site (including blocking certain ip addresses), to any person for any reason or for no reason, 
              including without limitation for breach of any representation, warranty, or covenant contained in these terms of 
              use or of any applicable law or regulation.
            </p>
            
            <h2 className="text-2xl font-bold text-client-yellow mt-8 mb-4">8. Contact Us</h2>
            <p className="text-white mb-6">
              In order to resolve a complaint regarding the Site or to receive further information regarding use of the Site, 
              please contact us at: terms@daryiankelton.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
